import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SvgIconsModule } from '@ngneat/svg-icon';
import { TranslateModule } from '@ngx-translate/core';
import { OnmatStoreProfileModule } from '@tekman/onmat/store/profile';
import { svgIcons } from '@tekman/shared/utils';
import { TypeformDirective } from './directives/typeform.directive';

@NgModule({
  imports: [CommonModule, SvgIconsModule.forChild(svgIcons), TranslateModule, RouterModule, OnmatStoreProfileModule],
  declarations: [TypeformDirective],
  exports: [TypeformDirective],
})
export class OnmatUtilsModule {}
